// extracted by mini-css-extract-plugin
module.exports = {"fav":"CardWatchButton_fav___PDQT","sm":"CardWatchButton_sm__Tv6Jd"};